import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

import { Alert, Button, FormField } from "../../../components/ui";
import { AuthShell } from "../../../layouts/AuthShell";
import { requestPasswordReset } from "../api/authApi";
import { forgotPasswordSchema } from "../schemas/authSchemas";

export function ForgotPasswordPage() {
  const [sent, setSent] = useState(false);
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<{ email: string }>({ resolver: zodResolver(forgotPasswordSchema), defaultValues: { email: "" } });
  const submit = handleSubmit(async ({ email }) => { await requestPasswordReset(email); setSent(true); });
  return <AuthShell title="忘記密碼"><>{sent && <Alert variant="success">若此帳號存在，我們已寄出密碼重設說明。</Alert>}<form onSubmit={(event) => void submit(event)}><FormField label="電子郵件" required error={errors.email?.message} {...register("email")} /><Button type="submit" loading={isSubmitting}>寄送重設說明</Button></form><p className="mt-3"><Link to="/login">返回登入</Link></p></></AuthShell>;
}
